// Modules
import React from 'react'
import OwlCarousel from 'react-owl-carousel'

// Styles
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

function Carousel ({ bannerContent, children }) {
	// Render
	return (
		<OwlCarousel
			nav
			center
			loop={bannerContent?.length > 1 ? true : false}
			autoplay
			dotsEach
			autoWidth
			items={3}
			margin={4}
			startPosition={1}>
			{children}
		</OwlCarousel>
	)
}

// Export
export default Carousel

